import NAME from "./constants";

export const RESET_STATE = NAME + "/RESET_STATE";
export const GET_QUANTITY_PER_SCREEN = NAME + "/GET_QUANTITY_PER_SCREEN";
export const GET_QUANTITY_PER_SCREEN_FULFILLED = NAME + "/GET_QUANTITY_PER_SCREEN_FULFILLED";
export const GET_QUANTITY_PER_SCREEN_REJECTED = NAME + "/GET_QUANTITY_PER_SCREEN_REJECTED";
